/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('WallPromoCtrl', function($scope, identity, term) {
    $scope.me     = identity;
    return $scope.params = {
        target:    'terms',
        entity_id: term.wall_name
    };
});
